module.exports = __webpack_public_path__ + "img/fuwu1.d3493e42.webp";